
import { i18nText } from '@/locales';
import { email, phone } from "@/utils/validators/rules.ts";

export class ClientGeneralFormData {
    id?: number;
    name: string;
    email: string;
    salon_id: number;
    phone: string;
    sex: number | null;
    category?: (number)[] | null;
    source?: (number)[] | null;
    birthday_date: string;
    comment: string;
    online: boolean;
    sold: number;
    paid: number;
    bonus_account_id?: null;

    constructor() {
        this.name = '';
        this.salon_id = 0;
        this.phone = '';
        this.sex = null;
        this.category = [];
        this.source = [];
        this.birthday_date = '';
        this.comment = '';
        this.online = false;
        this.sold = 0;
        this.paid = 0;
        this.email = '';
    }
}
export const activeSex = [
    { id: 1, name: i18nText("Мужской") },
    { id: 2, name: i18nText("Женский") }
];

export const FormRules = {
    name: [
        { required: true, whitespace: true, max: 255, message: i18nText("Пожалуйста укажите ФИО"), trigger: "change" }
    ],
    phone: [
        { required: true, message: i18nText("Пожалуйста укажите телефон"), trigger: "change" },
        { validator: phone, message: i18nText("Введите корректный номер телефона") }
    ],
    source: [{ required: true, message: i18nText("Пожалуйста укажите источник"), trigger: "change" }],
    email: [
        { required: false, message: i18nText("Пожалуйста введите email"), trigger: "change" },
        { validator: email, message: i18nText("Пожалуйста введите корректный email"), trigger: "change" }
    ]
};
